/**
 * Vite environment configuration (task-377).
 * Replaces CRA REACT_APP_* / process.env access.
 */

const backendUrl = (import.meta.env.VITE_BACKEND_URL ?? "").replace(/\/$/, "");

/** Backend origin without trailing slash; empty string = same-origin (use /api). */
export const BACKEND_URL = backendUrl;

/** API base path — relative when BACKEND_URL is empty (Firebase Hosting rewrite). */
export const API = backendUrl ? `${backendUrl}/api` : "/api";

export const IS_DEMO_MODE = import.meta.env.VITE_DEMO_MODE === "true";
export const IS_DEV = import.meta.env.DEV;
export const IS_PROD = import.meta.env.PROD;

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};
